import { requireAll } from "./register";

// Temporary Sequence fixtures are retained for local development and tests,
// but are not referenced by production code and include large embedded images.
const req = require.context(
  "./svg",
  true,
  /^\.\/(?!sequence\/temp\/).*\.svg$/
);
requireAll(req);

// These two icons live beside the retained fixtures but are used by production
// Sequence, Monitor, Custom Field, and Role/Team screens.
const referencedSequenceIcons = require.context(
  "./svg/sequence/temp",
  false,
  /^\.\/(seq-detail-back|seq-label-rename)\.svg$/
);
requireAll(referencedSequenceIcons);
